export default "__VITE_ASSET__CR2y3ZLc__"